import React from 'react';
import DashboardLayout from '@/shared/layout/DashboardLayout';
import ProviderPageHeader from '@/modules/provider-console/components/ProviderPageHeader';
import {useOrgReturnAction} from '@/modules/admin/hooks/useOrgReturnAction';

interface ProviderLayoutProps {
    /** Page title shown in the header */
    title: string;
    /** Optional subtitle under the title */
    subtitle?: string;
    /** Hide the "< Provider Console" breadcrumb (for the top-level Provider Console page) */
    hideBreadcrumb?: boolean;
    /** Optional action button on the right side of the page header area */
    action?: React.ReactNode;
    children: React.ReactNode;
}

/**
 * Standard layout wrapper for all Provider Console pages.
 *
 * Handles:
 * - DashboardLayout with the nav bar
 * - "Back to Org Console" button in the nav (when in admin-switch context)
 * - Page header with title, subtitle, breadcrumb back-link, and optional action slot
 *
 * Usage:
 *   <ProviderLayout title="Order Tests" subtitle="Create and manage lab orders">
 *       ...page content...
 *   </ProviderLayout>
 */
const ProviderLayout: React.FC<ProviderLayoutProps> = ({title, subtitle, hideBreadcrumb, action, children}) => {
    const orgReturnAction = useOrgReturnAction();

    return (
        <DashboardLayout headerAction={orgReturnAction}>
            <ProviderPageHeader title={title} subtitle={subtitle} hideBreadcrumb={hideBreadcrumb} action={action} />
            {children}
        </DashboardLayout>
    );
};

export default ProviderLayout;
